import { ReactElement } from 'react';
import classNames from 'classnames';
import { DialogPanel, DialogTitle } from '@headlessui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { useModal } from 'xstate/hooks/useModal';
import { CollectionModalPayload } from 'xstate/machines/ModalMachine';
import { closeModal } from 'xstate/actors/ModalActor';
import { CollectionForm } from 'elements/Collection';
import { useTranslations } from 'next-intl';

const CollectionModal = (): ReactElement => {
  const t = useTranslations();
  const { payload } = useModal() as { payload: CollectionModalPayload };
  const collection = payload?.collection;

  return (
    <div className={styles.outer}>
      <div className={styles.inner}>
        <DialogPanel transition className={styles.panel}>
          <div className={styles.header.container}>
            <DialogTitle as="h2" className={styles.header.title}>
              {collection
                ? t('collections.form.titleEdit')
                : t('collections.form.titleCreate')}
            </DialogTitle>
            <button
              type="button"
              onClick={closeModal}
              aria-label={t('common.close')}
              className={styles.header.close}
            >
              <FontAwesomeIcon icon={faXmark} />
            </button>
          </div>

          <CollectionForm collection={collection} onSuccess={closeModal} />
        </DialogPanel>
      </div>
    </div>
  );
};

const styles = {
  outer: 'fixed inset-0 z-10 w-screen overflow-y-auto',
  inner: 'flex min-h-full items-center justify-center p-4',
  panel: classNames(
    'w-full max-w-xl rounded-2xl bg-white text-left shadow-xl transition-all',
    'data-closed:opacity-0 data-closed:scale-95 data-enter:duration-200 data-leave:duration-150',
  ),
  header: {
    container: 'flex items-start justify-between gap-3 px-6 pt-6 pb-4',
    title: 'text-lg font-bold text-mf-off-black-950',
    close:
      'flex-none flex items-center justify-center w-8 h-8 rounded-full bg-gray-100 text-gray-500 hover:bg-gray-200',
  },
};

export default CollectionModal;
